import * as React from 'react'
import * as plume from '@ulule/owl-kit-components/next'

import { Container } from '../../_shared/Container'
import styles from './Newsletter.module.css'

export function Newsletter(): React.ReactElement {
  return (
    <section className={styles.newsletter}>
      <Container>
        <div className={styles.newsletter__band}>
          <span className={styles.newsletter__icon}>
            <plume.glyphs.stroke.News />
          </span>
          <p className={styles.newsletter__text}>
            La meilleure façon de suivre notre actu&nbsp;?{' '}
            <a href="/newsletter/" target="_blank" rel="noopener noreferrer">
              Abonnez-vous à la newsletter Ulule
            </a>
            .
          </p>
        </div>
      </Container>
    </section>
  )
}
